// I. GLOBAL INITIALIZATION FLAGS (using var for re-declaration safety if script is somehow processed multiple times)
if (typeof window.valsolePdpGlobalInit === 'undefined') {
  window.valsolePdpGlobalInit = {}; // Namespace for our flags
  window.valsolePdpGlobalInit.domContentLoadedProcessed = false;
  window.valsolePdpGlobalInit.mainLogicExecuted = false;
  // Settings will be populated later, can be declared here if needed for linters
  var showUnavailableOptionsSetting = false; 
  var soldOutText = 'Sold Out';
  var unavailableText = 'Unavailable';
}

// [DEBUG] initial load message suppressed (moved under DEBUG_MODE flag)

// DEBUG MODE CONTROL (inserted to mute [DEBUG] console logs by default)
if (typeof window.DEBUG_MODE === 'undefined') {
  window.DEBUG_MODE = false; // Set to true in the browser console to re-enable internal debug logging
}

// Patch console.log so that messages starting with "[DEBUG]" only print when DEBUG_MODE is true
(function() {
  if (console.__valsoleDebugPatched) return; // Prevent double-patching on re-loads
  const originalLog = console.log.bind(console);
  console.log = function(...args) {
    if (args.length && typeof args[0] === 'string') {
      const firstArgStr = args[0];
      const silencePatterns = ['[DEBUG]', 'cart-popup.js', '[renderCart]', 'CartPopup'];
      const matchesSilenced = silencePatterns.some(pattern => firstArgStr.includes(pattern));
      if (matchesSilenced) {
        if (window.DEBUG_MODE) {
          originalLog(...args);
        }
        return; // Suppress when not in DEBUG_MODE
      }
    }
    originalLog(...args);
  };
  console.__valsoleDebugPatched = true;
})();

// II. DOMCONTENTLOADED LISTENER
document.addEventListener('DOMContentLoaded', function() {
  if (window.valsolePdpGlobalInit.domContentLoadedProcessed && window.location.href === window.valsolePdpGlobalInit.lastProcessedUrl) {
    console.log('[DEBUG] DOMContentLoaded: Already processed for this exact URL. Skipping subsequent identical fires.');
    return;
  }
  // If it's a new URL (e.g., Turbo navigation) or first time, reset main logic flag and proceed
  if (window.location.href !== window.valsolePdpGlobalInit.lastProcessedUrl) {
      window.valsolePdpGlobalInit.mainLogicExecuted = false; 
  }
  window.valsolePdpGlobalInit.domContentLoadedProcessed = true;
  window.valsolePdpGlobalInit.lastProcessedUrl = window.location.href;

  console.log('[DEBUG] DOMContentLoaded: Event fired. document.readyState:', document.readyState);

  // Accordion setup (can be here as it's self-contained)
  document.querySelectorAll('.js-accordion .accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const plusIcon = this.querySelector('.accordion_icon.plus');
      const minusIcon = this.querySelector('.accordion_icon.minus');
      const isOpen = content.style.height !== '0px' && content.style.height !== '';

      // Close all other accordions first
      document.querySelectorAll('.js-accordion .accordion-content').forEach(otherContent => {
        if (otherContent !== content) {
          otherContent.style.height = '0px';
          const otherTrigger = otherContent.previousElementSibling;
          if (otherTrigger) {
            const otherPlus = otherTrigger.querySelector('.accordion_icon.plus');
            const otherMinus = otherTrigger.querySelector('.accordion_icon.minus');
            if (otherPlus) otherPlus.style.opacity = '1';
            if (otherMinus) otherMinus.style.display = 'none'; // Hide minus completely
          }
        }
      });

      // Then, toggle the current one
      if (isOpen) {
        content.style.height = '0px';
        if (plusIcon) plusIcon.style.opacity = '1';
        if (minusIcon) minusIcon.style.display = 'none';
      } else {
        content.style.height = content.scrollHeight + 'px';
        if (plusIcon) plusIcon.style.opacity = '0';
        if (minusIcon) minusIcon.style.display = 'block'; // Show minus
      }
    });
  });

  // III. SETIMEOUT FOR MAIN LOGIC
  setTimeout(function() {
    if (window.valsolePdpGlobalInit.mainLogicExecuted) {
      console.log('[DEBUG] setTimeout: Main logic already executed for this page content. Skipping.');
      return;
    }
    window.valsolePdpGlobalInit.mainLogicExecuted = true;
    console.log('[DEBUG] setTimeout: Executing main logic batch.');

    // A. Initialize settings from DOM (assign to global vars declared above)
    const pdpWrapper = document.querySelector('.pdp_wrapper');
    if (pdpWrapper) {
        showUnavailableOptionsSetting = pdpWrapper.dataset.showUnavailableOptions === 'true';
        soldOutText = pdpWrapper.dataset.showUnavailableOptionsTextSoldOut || 'Sold Out';
        unavailableText = pdpWrapper.dataset.showUnavailableOptionsTextUnavailable || 'Unavailable';
    } else {
        console.warn('[DEBUG] .pdp_wrapper not found. Using default for unavailable options settings.');
        // Defaults are already set globally, so no need to re-set here unless pdpWrapper is crucial for other things
    }
    console.log('[DEBUG] setTimeout: showUnavailableOptionsSetting is now:', showUnavailableOptionsSetting);

    const preOrderConfig = {
      enabled: pdpWrapper
        ? pdpWrapper.dataset.preorderEnabled === 'true'
        : !!(window.valsolePreorderConfig && window.valsolePreorderConfig.enabled),
      buttonText: (pdpWrapper && pdpWrapper.dataset.preorderButtonText)
        || (window.valsolePreorderConfig && window.valsolePreorderConfig.buttonText)
        || 'Pre-order',
      badgeText: (pdpWrapper && pdpWrapper.dataset.preorderBadgeText)
        || (window.valsolePreorderConfig && window.valsolePreorderConfig.defaultBadgeText)
        || 'Pre-order',
      defaultNote: (pdpWrapper && pdpWrapper.dataset.preorderDefaultNote)
        || (window.valsolePreorderConfig && window.valsolePreorderConfig.defaultNote)
        || 'Pre-order now. Estimated shipping date shown at checkout.',
      showNotice: pdpWrapper ? pdpWrapper.dataset.preorderShowNotice === 'true' : true,
      showPriceBadge: pdpWrapper ? pdpWrapper.dataset.preorderShowPriceBadge === 'true' : true
    };

    const isPreorderVariant = function(variant) {
      if (!preOrderConfig.enabled || !variant || !variant.available) return false;
      const inventoryMap = window.valsoleVariantInventory || {};
      const inventory = inventoryMap[String(variant.id)] || {};
      const policy = String(variant.inventory_policy ?? inventory.inventory_policy ?? '').toLowerCase();
      const management = String(variant.inventory_management ?? inventory.inventory_management ?? '').toLowerCase();
      const quantity = Number(variant.inventory_quantity ?? inventory.inventory_quantity);
      if (Number.isNaN(quantity)) return false;
      return (
        policy === 'continue' &&
        management === 'shopify' &&
        quantity <= 0
      );
    };

    const getPreorderNote = function(variant) {
      const variantId = variant ? String(variant.id) : '';
      const variantNotes = window.valsolePreorderVariantNotes || {};
      const variantNote = variantId ? String(variantNotes[variantId] || '').trim() : '';
      const productNote = String(window.valsolePreorderProductNote || '').trim();
      return variantNote || productNote || preOrderConfig.defaultNote;
    };

    const getPreorderBadgeText = function(variant) {
      const variantId = variant ? String(variant.id) : '';
      const variantBadges = window.valsolePreorderVariantBadges || {};
      const variantBadge = variantId ? String(variantBadges[variantId] || '').trim() : '';
      const productBadge = String(window.valsolePreorderProductBadge || '').trim();
      return variantBadge || productBadge || preOrderConfig.badgeText;
    };

    // Ensure product data is available (Shopify usually makes `product` global via product | json filter)
    if (typeof product === 'undefined' || !product || !product.id) {
        console.error('[DEBUG] setTimeout: Product data object not found or invalid. Aborting PDP logic.');
        return;
    }
    console.log('[DEBUG] setTimeout: Product data ID:', product.id);
    if (!product.options_by_name) {
        console.warn('[DEBUG] setTimeout: product.options_by_name not found. This might cause issues.');
        // Potentially reconstruct if needed, though it should come from Liquid
    }

    // B. DEFINE CORE FUNCTIONS (now within setTimeout scope, can see each other)
    // getProductOptionDetails, getAllSelectedOptions, updateAvailableOptions, updateSelectedVariant, updateSizePillsDisplay

    const getProductOptionDetails = function(optionNameLower) {
        if (typeof product !== 'undefined' && product && product.options_by_name) {
            for (const keyInLoop in product.options_by_name) {
                if (product.options_by_name.hasOwnProperty(keyInLoop) && keyInLoop.toLowerCase() === optionNameLower) {
                    return product.options_by_name[keyInLoop];
                }
            }
        }
        return null;
    };

    const getAllSelectedOptions = function() {
        const selections = {};
        const activeGenderToggle = document.querySelector('.sex-toggle_wrapper .sex_toggle.is-active');
        const genderOptionDetails = getProductOptionDetails('gender');
        if (activeGenderToggle && genderOptionDetails) {
            selections[genderOptionDetails.name.toLowerCase()] = activeGenderToggle.dataset.genderOriginal;
        } else if (activeGenderToggle && !genderOptionDetails) {
            selections['gender'] = activeGenderToggle.dataset.genderOriginal.toLowerCase();
        }
        document.querySelectorAll('.product-option-container').forEach(container => {
            const optionName = container.dataset.optionName;
            const optionNameLower = optionName.toLowerCase();
            if (selections[optionNameLower] && optionNameLower === (genderOptionDetails ? genderOptionDetails.name.toLowerCase() : 'gender')) return;
            const activePill = container.querySelector('.option-pill.is-active');
            if (activePill && activePill.style.display !== 'none') {
                selections[optionNameLower] = activePill.dataset.value;
            } else {
                /* If not pill-type (e.g., swatches), read from hidden select */
                const hiddenSelect = container.querySelector('select.product-option-hidden-select');
                if (hiddenSelect && hiddenSelect.value) {
                    selections[optionNameLower] = hiddenSelect.value;
                } else {
                    if (selections[optionNameLower]) delete selections[optionNameLower];
                }
            }
        });
        console.log('[DEBUG] getAllSelectedOptions returns:', selections);
        return selections;
    };

    const setSoldOutState = function(uiElement, isSoldOut) {
        if (!uiElement) return;
        uiElement.classList.toggle('leads-to-sold-out', !!isSoldOut);
        uiElement.classList.toggle('is-sold-out', !!isSoldOut);
    };

    const isSoldOutPill = function(uiElement) {
        if (!uiElement) return false;
        return uiElement.classList.contains('leads-to-sold-out') || uiElement.classList.contains('is-sold-out');
    };

    const updateSelectedVariant = function() {
        console.log('[DEBUG] updateSelectedVariant: Called.');
        if (typeof product === 'undefined' || !product || !product.variants || !product.options_by_name) {
            console.error('[DEBUG] updateSelectedVariant: Product data missing.');
            return;
        }
        const currentSelections = getAllSelectedOptions(); 
        console.log('[DEBUG] updateSelectedVariant: currentSelections:', currentSelections);
        let matchedVariant = null;
        let bestMatchAvailable = null;
        product.variants.forEach(variant => {
            let allOptionsMatch = true;
            for (const selectedOptionNameLower in currentSelections) {
                if (!currentSelections.hasOwnProperty(selectedOptionNameLower)) continue;
                const selectedValue = currentSelections[selectedOptionNameLower];
                let optionDetailFromProduct = getProductOptionDetails(selectedOptionNameLower);
                if (!optionDetailFromProduct) {
                    // If the store does not have a real 'gender' option, simply ignore it for variant matching
                    if (selectedOptionNameLower === 'gender') {
                        continue; // Skip and keep evaluating other options
                    } else {
                         allOptionsMatch = false; break;
                    }
                }
                if (optionDetailFromProduct) { 
                    const optionPositionIndex = optionDetailFromProduct.position - 1;
                    if (variant.options.length > optionPositionIndex) {
                        const variantOptionValue = variant.options[optionPositionIndex];
                        if (variantOptionValue === null || typeof variantOptionValue === 'undefined') { allOptionsMatch = false; break; }
                        const variantOptionValueLower = String(variantOptionValue).toLowerCase();
                        const selectedValueLower = String(selectedValue).toLowerCase();
                        if (selectedOptionNameLower === 'gender') {
                            const isManSynonym = (s) => ['man', 'male', 'm'].includes(s);
                            const isWomanSynonym = (s) => ['woman', 'female', 'w', 'fem'].includes(s);
                            const isUnisexSynonym = (s) => ['unisex', 'uni', 'all'].includes(s);
                            if (!((isManSynonym(variantOptionValueLower) && isManSynonym(selectedValueLower)) || (isWomanSynonym(variantOptionValueLower) && isWomanSynonym(selectedValueLower)) || (isUnisexSynonym(variantOptionValueLower) && isUnisexSynonym(selectedValueLower)) || (variantOptionValueLower === selectedValueLower))) {
                                allOptionsMatch = false; break;
                            }
                        } else { 
                            if (variantOptionValueLower !== selectedValueLower) { allOptionsMatch = false; break; }
                        }
                    } else { allOptionsMatch = false; break; }
                }
            }
            if (allOptionsMatch) {
                if (variant.available) { if (!bestMatchAvailable) { bestMatchAvailable = variant; } }
                if (!matchedVariant) { matchedVariant = variant; }
            }
        });
        if (bestMatchAvailable) { matchedVariant = bestMatchAvailable; }
        console.log('[DEBUG] updateSelectedVariant: Matched variant ID:', matchedVariant ? matchedVariant.id : 'None', 'Available:', matchedVariant ? matchedVariant.available : 'N/A');
        const mainProductForm = document.querySelector('form[data-type="add-to-cart-form"]:not(.sub-product-form)');
        if (!mainProductForm) { console.error("[DEBUG] updateSelectedVariant: Main product form not found."); return; }
        const mainHiddenVariantInput = mainProductForm.querySelector('input[name="id"]');
        const floatingCartVariantInput = document.querySelector('.floating-cart-variant-id');
        const priceElement = document.querySelector('.pdp_content .price:not(.compare-price)');
        const comparePriceElement = document.querySelector('.pdp_content .compare-price');
        const saleTagElement = document.querySelector('.pdp_content .sale-tag');
        const markdownBadge = document.querySelector('[data-valsole-markdown-badge]');
        const atcButton = mainProductForm.querySelector('.product-form__submit');
        const atcButtonText = atcButton ? atcButton.querySelector('.add-to-cart-text') : null;
        const floatingCartPriceElement = document.querySelector('.floating-cart-price');
        const floatingCartATCButton = document.querySelector('.floating-cart-atc');
        const floatingCartATCButtonTextSpan = floatingCartATCButton ? floatingCartATCButton.querySelector('.add-to-cart-text') : null;
        const lowStockBanner = document.querySelector('.low-stock-alert-banner');
        const preorderNotice = document.querySelector('[data-preorder-note]');
        const preorderNoticeText = preorderNotice ? preorderNotice.querySelector('[data-preorder-note-text]') : null;
        const preorderPriceBadge = document.querySelector('[data-preorder-price-badge]');
        const preorderPriceBadgeText = preorderPriceBadge ? preorderPriceBadge.querySelector('[data-preorder-price-badge-text]') : null;
        const preorderPropertyInput = mainProductForm.querySelector('[data-preorder-property]');
        const preorderNotePropertyInput = mainProductForm.querySelector('[data-preorder-note-property]');

        if (matchedVariant) {
            const preorderActive = isPreorderVariant(matchedVariant);
            const preorderNote = preorderActive ? getPreorderNote(matchedVariant) : '';
            const preorderBadgeText = preorderActive ? getPreorderBadgeText(matchedVariant) : '';
            if (mainHiddenVariantInput) mainHiddenVariantInput.value = matchedVariant.id;
            if (floatingCartVariantInput) floatingCartVariantInput.value = matchedVariant.id;
            if (preorderPropertyInput) preorderPropertyInput.value = preorderActive ? 'true' : '';
            if (preorderNotePropertyInput) preorderNotePropertyInput.value = preorderActive ? preorderNote : '';
            
            let formattedPrice = formatPriceFallback(matchedVariant.price, window.shopCurrency || '$');
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) { 
                try { 
                    formattedPrice = Shopify.formatMoney(matchedVariant.price, Shopify.money_format || window.Shopify.currency.money_format || '%${{amount}}'); 
                } catch (e) { 
                    console.warn("Shopify.formatMoney error", e); 
                } 
            }

            if (priceElement) {
                if (matchedVariant.available) {
                    priceElement.textContent = formattedPrice;
                    console.log('[DEBUG] Price Update: Set to', formattedPrice);
                } else {
                    priceElement.textContent = soldOutText;
                    console.log('[DEBUG] Price Update: Set to Sold Out text');
                }
            } else { 
                console.log('[DEBUG] Price Update: priceElement NOT found.'); 
            }

            if (comparePriceElement && saleTagElement) {
                if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
                    let formattedCompareAtPrice = formatPriceFallback(matchedVariant.compare_at_price, window.shopCurrency || '$');
                    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) { try { formattedCompareAtPrice = Shopify.formatMoney(matchedVariant.compare_at_price, Shopify.money_format || window.Shopify.currency.money_format || '%${{amount}}'); } catch (e) { console.warn("Shopify.formatMoney error for compare_at_price", e); } }
                    comparePriceElement.textContent = formattedCompareAtPrice; comparePriceElement.classList.remove('hide'); saleTagElement.classList.remove('hide');
                    const salePercentage = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price);
                    const saleTextBlocks = saleTagElement.querySelectorAll('.text-block-2');
                    if (saleTextBlocks.length > 0) saleTextBlocks[0].textContent = salePercentage + '%';
                } else { comparePriceElement.textContent = ''; comparePriceElement.classList.add('hide'); saleTagElement.classList.add('hide'); }
            }
            if (markdownBadge) {
                markdownBadge.hidden = !(matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price);
            }
            if (atcButton && atcButtonText) { if (matchedVariant.available) { atcButtonText.textContent = `${preorderActive ? preOrderConfig.buttonText : 'Add to Cart'} — ${formattedPrice}`; atcButton.disabled = false; } else { atcButtonText.textContent = soldOutText; atcButton.disabled = true; } }
            if (floatingCartPriceElement) floatingCartPriceElement.textContent = formattedPrice;
            if (floatingCartATCButton && floatingCartATCButtonTextSpan) { if (matchedVariant.available) { floatingCartATCButtonTextSpan.innerHTML = `${preorderActive ? preOrderConfig.buttonText : 'Add to Cart'} — <span class="floating-cart-price">${formattedPrice}</span>`; floatingCartATCButton.disabled = false; } else { floatingCartATCButtonTextSpan.textContent = soldOutText; floatingCartATCButton.disabled = true; } }
            if (preorderNotice && preOrderConfig.showNotice) {
                if (preorderActive) {
                    preorderNotice.classList.remove('is-hidden');
                    if (preorderNoticeText) preorderNoticeText.textContent = preorderNote;
                } else {
                    preorderNotice.classList.add('is-hidden');
                }
            }
            if (preorderPriceBadge && preOrderConfig.showPriceBadge) {
                if (preorderActive) {
                    preorderPriceBadge.classList.remove('is-hidden');
                    if (preorderPriceBadgeText) preorderPriceBadgeText.textContent = preorderBadgeText;
                } else {
                    preorderPriceBadge.classList.add('is-hidden');
                }
            }
            if (lowStockBanner) {
                const inventoryMap = window.valsoleVariantInventory || {};
                const inv = inventoryMap[String(matchedVariant.id)] || {};
                const policy = String(matchedVariant.inventory_policy ?? inv.inventory_policy ?? '').toLowerCase();
                const management = String(matchedVariant.inventory_management ?? inv.inventory_management ?? '').toLowerCase();
                const quantity = Number(matchedVariant.inventory_quantity ?? inv.inventory_quantity);
                lowStockBanner.style.display = (
                    matchedVariant.available &&
                    management === 'shopify' &&
                    policy === 'deny' &&
                    !Number.isNaN(quantity) &&
                    quantity <= 10 &&
                    quantity > 0
                ) ? 'block' : 'none';
            }
            try { const url = new URL(window.location.href); url.searchParams.set('variant', matchedVariant.id); window.history.replaceState({}, '', url.toString()); } catch (e) { console.warn('[DEBUG] updateSelectedVariant: Error updating URL:', e); }

            // === Actualizar grid de imágenes ===
            updateMediaGridByVariant(matchedVariant);
        } else {
            if (mainHiddenVariantInput) mainHiddenVariantInput.value = '';
            if (preorderPropertyInput) preorderPropertyInput.value = '';
            if (preorderNotePropertyInput) preorderNotePropertyInput.value = '';
            if (priceElement) priceElement.textContent = unavailableText;
            if (comparePriceElement) comparePriceElement.classList.add('hide');
            if (saleTagElement) saleTagElement.classList.add('hide');
            if (atcButton && atcButtonText) { atcButtonText.textContent = unavailableText; atcButton.disabled = true; }
            if (floatingCartVariantInput) floatingCartVariantInput.value = '';
            if (floatingCartATCButton && floatingCartATCButtonTextSpan) { floatingCartATCButtonTextSpan.textContent = unavailableText; floatingCartATCButton.disabled = true; }
            if (preorderNotice) preorderNotice.classList.add('is-hidden');
            if (preorderPriceBadge) preorderPriceBadge.classList.add('is-hidden');
            if (lowStockBanner) lowStockBanner.style.display = 'none';

            // Cuando no hay variante válida, mostramos todas las imágenes.
            updateMediaGridByVariant(null);
        }
    };

    const updateAvailableOptions = function(changedOptionName = null) {
        if (typeof product === 'undefined' || !product || !product.variants || !product.options_by_name) return;
        const currentSelections = getAllSelectedOptions();
        console.log('[DEBUG] updateAvailableOptions - currentSelections:', currentSelections, 'changedOption:', changedOptionName);
        for (const optNameKey in product.options_by_name) {
            if (!product.options_by_name.hasOwnProperty(optNameKey)) continue;
            const optionDetail = product.options_by_name[optNameKey];
            const optionNameLower = optionDetail.name.toLowerCase();
            const optionContainer = document.querySelector(`.product-option-container[data-option-name="${optionDetail.name}"]`);
            if (!optionContainer) continue;
            const isPillType = optionContainer.dataset.optionType === 'pills';
            const pillsOrOptions = isPillType ? optionContainer.querySelectorAll('.option-pill') : optionContainer.querySelectorAll('select.product-option-hidden-select option');
            pillsOrOptions.forEach(uiElement => {
                const valueToCheck = isPillType ? uiElement.dataset.value : uiElement.value;
                let variantExistsForThisValue = false;
                let leadsToAvailableVariant = false;
                for (const variant of product.variants) {
                    let matchesOtherSelections = true;
                    for (const optKeyFromProduct_inner in product.options_by_name) {
                        if (!product.options_by_name.hasOwnProperty(optKeyFromProduct_inner)) continue;
                        const otherOptionDetail_inner = product.options_by_name[optKeyFromProduct_inner];
                        const otherOptionNameLower_inner = otherOptionDetail_inner.name.toLowerCase();
                        if (otherOptionNameLower_inner === optionNameLower) continue;
                        const selectedValueForOtherOption = currentSelections[otherOptionNameLower_inner];
                        if (selectedValueForOtherOption !== undefined && selectedValueForOtherOption !== null && selectedValueForOtherOption !== '') {
                            const variantOptionIndex = otherOptionDetail_inner.position - 1;
                            if (variant.options.length <= variantOptionIndex || (variant.options[variantOptionIndex] || '').toLowerCase() !== selectedValueForOtherOption.toLowerCase()) {
                                matchesOtherSelections = false; break;
                            }
                        } 
                    }
                    if (matchesOtherSelections) {
                        const currentOptionIndex = optionDetail.position - 1;
                        if (variant.options.length > currentOptionIndex && (variant.options[currentOptionIndex] || '').toLowerCase() === (valueToCheck || '').toLowerCase()) {
                            variantExistsForThisValue = true;
                            if (variant.available) { leadsToAvailableVariant = true; }
                        }
                    }
                    if (leadsToAvailableVariant) break;
                }
                if (isPillType) {
                    if (showUnavailableOptionsSetting) {
                        uiElement.style.display = variantExistsForThisValue ? '' : 'none';
                        setSoldOutState(uiElement, variantExistsForThisValue && !leadsToAvailableVariant);
                        if (!variantExistsForThisValue && uiElement.classList.contains('is-active')) { uiElement.classList.remove('is-active'); }
                    } else {
                        uiElement.style.display = leadsToAvailableVariant ? '' : 'none';
                        setSoldOutState(uiElement, false);
                        if (!leadsToAvailableVariant && uiElement.classList.contains('is-active')) { uiElement.classList.remove('is-active'); }
                    }
                } else { /* selects not used */ }
            });
            if (isPillType) {
                const activePillsInOption = optionContainer.querySelectorAll('.option-pill.is-active');
                let visiblePillsInOption = Array.from(optionContainer.querySelectorAll('.option-pill')).filter(p => p.style.display !== 'none');
                if (visiblePillsInOption.length > 0 && activePillsInOption.length === 0) {
                    let pillToActivate = visiblePillsInOption.find(p => !isSoldOutPill(p));
                    if (!pillToActivate) pillToActivate = visiblePillsInOption[0];
                    pillToActivate.classList.add('is-active');
                    const hiddenSelect = optionContainer.querySelector('select.visually-hidden.product-option-hidden-select');
                    if (hiddenSelect) hiddenSelect.value = pillToActivate.dataset.value;
                } else if (visiblePillsInOption.length === 0 && activePillsInOption.length > 0) {
                    const hiddenSelect = optionContainer.querySelector('select.visually-hidden.product-option-hidden-select');
                    if (hiddenSelect) hiddenSelect.value = '';
                }
            }
        }
        if (typeof updateSelectedVariant === 'function') { updateSelectedVariant(); }
        else { console.error("[DEBUG] updateSelectedVariant is not a function when called from updateAvailableOptions"); }
    };

    // Expose helper for other inline scripts (e.g., color swatch logic)
    if (typeof window !== 'undefined') {
      window.ValsolePDP = window.ValsolePDP || {};
      window.ValsolePDP.updateAvailableOptions = updateAvailableOptions;
    }

    const updateSizePillsDisplay = function(selectedGenderOriginal) {
        if (typeof product === 'undefined' || !product || !product.variants) { /* ... */ return; }
        console.log('[DEBUG] updateSizePillsDisplay: Gender:', selectedGenderOriginal);
        const normalizedGenderKey = (() => {
            const raw = String(selectedGenderOriginal || '').toLowerCase();
            if (raw.includes('man') || raw.includes('male')) return 'men';
            if (raw.includes('woman') || raw.includes('female')) return 'women';
            return '';
        })();
        const genderOptionDetails = getProductOptionDetails('gender');
        let sizeOptionDetails = null;
        if (product.options_by_name) {
            for (const keyInLoop in product.options_by_name) {
                if (product.options_by_name.hasOwnProperty(keyInLoop) && keyInLoop.toLowerCase().includes('size')) {
                    sizeOptionDetails = product.options_by_name[keyInLoop]; break;
                }
            }
        }
        const genderOptionIndex = genderOptionDetails ? genderOptionDetails.position - 1 : -1;
        const sizeOptionIndex = sizeOptionDetails ? sizeOptionDetails.position - 1 : -1;
        let firstAvailableSizePill = null; let visiblePillCount = 0;
        document.querySelectorAll('.size-selector-container[data-option-name*="Size"]').forEach((container) => {
            const existingSingleGender = container.dataset.activeGender === 'men' || container.dataset.activeGender === 'women'
              ? container.dataset.activeGender
              : '';
            container.dataset.activeGender = normalizedGenderKey || existingSingleGender || '';
        });
        document.querySelectorAll('.size-selector-container[data-option-name*="Size"] .option-pill.size-selector-value').forEach((sizeButton) => {
            const fullValue = sizeButton.dataset.fullValue || sizeButton.dataset.value; // Prefer fullValue if exists
            const matchingVariants = [];
            if (selectedGenderOriginal && genderOptionIndex !== -1 && sizeOptionIndex !== -1) {
                for (const variant of product.variants) {
                    if (variant.options[genderOptionIndex]?.toLowerCase() === selectedGenderOriginal.toLowerCase() && variant.options[sizeOptionIndex] === fullValue) {
                        matchingVariants.push(variant);
                    }
                }
            } else if (!selectedGenderOriginal && sizeOptionIndex !== -1) { 
                 for (const variant of product.variants) {
                    if (variant.options[sizeOptionIndex] === fullValue) {
                        matchingVariants.push(variant);
                    }
                 }
            } else if (sizeOptionIndex !== -1) { 
                 for (const variant of product.variants) {
                    if (variant.options[sizeOptionIndex] === fullValue) {
                        matchingVariants.push(variant);
                    }
                 }
            } else if (product.variants.length > 0) {
                matchingVariants.push(...product.variants);
            }

            const variantExistsForGender = matchingVariants.length > 0;
            const isAvailableForGender = matchingVariants.some(variant => variant.available);
            const shouldShowSizePill = showUnavailableOptionsSetting ? variantExistsForGender : isAvailableForGender;
            const isSoldOutForGender = shouldShowSizePill && variantExistsForGender && !isAvailableForGender;

            const optionNameDiv = sizeButton.querySelector('.option-name');
            const sizeContainer = sizeButton.closest('.size-selector-container');
            const hasGenderContext = sizeContainer?.classList.contains('has-gender-context');
            const inferredSingleGender = !hasGenderContext && (sizeContainer?.dataset.activeGender === 'men' || sizeContainer?.dataset.activeGender === 'women')
              ? sizeContainer.dataset.activeGender
              : '';
            if (shouldShowSizePill) {
                sizeButton.style.display = ''; visiblePillCount++;
                sizeButton.dataset.activeGender = normalizedGenderKey || inferredSingleGender || '';
                setSoldOutState(sizeButton, isSoldOutForGender);
                if (!firstAvailableSizePill && !isSoldOutForGender) firstAvailableSizePill = sizeButton;
                let displaySizeText = '';
                let displayGenderPrefix = '';
                const currentSelectedGenderLower = selectedGenderOriginal ? selectedGenderOriginal.toLowerCase() : null;
                const manSize = sizeButton.dataset.manSize; const womanSize = sizeButton.dataset.womanSize;
                if (currentSelectedGenderLower === 'men' || currentSelectedGenderLower === 'man' || currentSelectedGenderLower === 'male') {
                    displaySizeText = manSize || fullValue.replace(/US\s*M\s*|US\s*W\s*|\/\s*W\s*|\/\s*M\s*/gi, '').trim();
                    displayGenderPrefix = 'M';
                }
                else if (currentSelectedGenderLower === 'women' || currentSelectedGenderLower === 'woman' || currentSelectedGenderLower === 'female') {
                    displaySizeText = womanSize || fullValue.replace(/US\s*M\s*|US\s*W\s*|\/\s*W\s*|\/\s*M\s*/gi, '').trim();
                    displayGenderPrefix = 'W';
                }
                else if (inferredSingleGender === 'men') {
                    displaySizeText = manSize || fullValue.replace(/US\s*M\s*|US\s*W\s*|\/\s*W\s*|\/\s*M\s*/gi, '').trim();
                    displayGenderPrefix = 'M';
                }
                else if (inferredSingleGender === 'women') {
                    displaySizeText = womanSize || fullValue.replace(/US\s*M\s*|US\s*W\s*|\/\s*W\s*|\/\s*M\s*/gi, '').trim();
                    displayGenderPrefix = 'W';
                }
                else {
                    if (manSize && womanSize && manSize === womanSize) {
                        displaySizeText = manSize;
                    } else if (manSize && womanSize) {
                        displaySizeText = `M${manSize} / W${womanSize}`;
                    } else if (manSize && (!womanSize || currentSelectedGenderLower === 'unisex' )) {
                        displaySizeText = manSize;
                    } else if (womanSize && (!manSize || currentSelectedGenderLower === 'unisex' )) {
                        displaySizeText = womanSize;
                    } else {
                        displaySizeText = fullValue.replace(/US\s*M\s*|US\s*W\s*|\/\s*W\s*|\/\s*M\s*/gi, '').trim();
                    }
                }
                const shouldPrefixGender = (hasGenderContext || inferredSingleGender) && displayGenderPrefix;
                if (optionNameDiv) {
                    optionNameDiv.textContent = shouldPrefixGender
                      ? `${displayGenderPrefix} ${displaySizeText}`
                      : displaySizeText;
                }
                sizeButton.dataset.genderBadge = shouldPrefixGender ? displayGenderPrefix : '';
            } else {
                sizeButton.style.display = 'none';
                sizeButton.dataset.activeGender = '';
                sizeButton.dataset.genderBadge = '';
                setSoldOutState(sizeButton, false);
                if (sizeButton.classList.contains('is-active')) { sizeButton.classList.remove('is-active'); }
            }
        });
        const currentActivePill = document.querySelector('.size-selector-container[data-option-name*="Size"] .option-pill.is-active');
        if (visiblePillCount > 0 && (!currentActivePill || currentActivePill.style.display === 'none' || isSoldOutPill(currentActivePill))) {
            if (firstAvailableSizePill) {
                firstAvailableSizePill.classList.add('is-active');
                const hiddenSelect = firstAvailableSizePill.closest('.size-selector-container').querySelector('select.visually-hidden.product-option-hidden-select');
                if (hiddenSelect) { hiddenSelect.value = firstAvailableSizePill.dataset.value; hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));}
            }
        } else if (visiblePillCount === 0) { /* ... clear active & hidden select ... */ }
        // DO NOT CALL updateSelectedVariant() here. Let it be called by updateAvailableOptions or initial setup calls.
        console.log('[DEBUG] updateSizePillsDisplay finished.');
    };

    // C. SET UP EVENT LISTENERS
    console.log('[DEBUG] setTimeout: Setting up event listeners.');
    const sexTogglesForSetup = document.querySelectorAll('.sex-toggle_wrapper .sex_toggle');
    const sexIndicator = document.querySelector('.sex_indicator');
    sexTogglesForSetup.forEach(toggle => {
      toggle.addEventListener('click', function() {
        console.log('[DEBUG] Gender toggle click for:', this.dataset.genderOriginal);
        sexTogglesForSetup.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        const activeGenderOriginal = this.dataset.genderOriginal;
        const genderKey = (this.dataset.genderKey || '').toLowerCase();
        if (sexIndicator) sexIndicator.textContent = `${activeGenderOriginal} sizing`;
        document.querySelectorAll('.sex-toggle_wrapper').forEach((wrapper) => {
          wrapper.dataset.activeGender = genderKey;
        });
        updateSizePillsDisplay(activeGenderOriginal); // Update size pill display/text first
        updateAvailableOptions('gender'); // Then update all options based on new gender
      });
    });

    document.querySelectorAll('.product-option-container .option-pill').forEach(pill => {
      const optionContainer = pill.closest('.product-option-container');
      const optionName = optionContainer.dataset.optionName;
      pill.addEventListener('click', function() {
        if (this.style.display === 'none') return;
        console.log(`[DEBUG] Pill click for option "${optionName}", value "${this.dataset.value}"`);
        optionContainer.querySelectorAll('.option-pill').forEach(p => p.classList.remove('is-active'));
        this.classList.add('is-active');
        const hiddenSelect = optionContainer.querySelector('select.visually-hidden.product-option-hidden-select');
        if (hiddenSelect) hiddenSelect.value = this.dataset.value;
        
        if (optionName.toLowerCase().includes('size')) {
            // If size changed, gender context for size labels might need update (though sex_indicator handles general case)
            // updateSizePillsDisplay might not be needed here if gender hasn't changed.
            // The primary action is to update all available options and the variant.
        }
        updateAvailableOptions(optionName.toLowerCase());
      });
    });

    // D. INITIAL PAGE SETUP CALLS
    console.log('[DEBUG] setTimeout: Starting initial UI setup.');
    const initiallyActiveGenderToggle = document.querySelector('.sex-toggle_wrapper .sex_toggle.is-active');
    let initialGender = null;
    if (initiallyActiveGenderToggle) {
        initialGender = initiallyActiveGenderToggle.dataset.genderOriginal;
        if (sexIndicator) sexIndicator.textContent = `${initialGender} sizing`;
        document.querySelectorAll('.sex-toggle_wrapper').forEach((wrapper) => {
          wrapper.dataset.activeGender = (initiallyActiveGenderToggle.dataset.genderKey || '').toLowerCase();
        });
    } else if (sexTogglesForSetup.length > 0) {
        sexTogglesForSetup[0].classList.add('is-active');
        initialGender = sexTogglesForSetup[0].dataset.genderOriginal;
        if (sexIndicator) sexIndicator.textContent = `${initialGender} sizing`;
        document.querySelectorAll('.sex-toggle_wrapper').forEach((wrapper) => {
          wrapper.dataset.activeGender = (sexTogglesForSetup[0].dataset.genderKey || '').toLowerCase();
        });
        console.log('[DEBUG] Initial: Auto-activated first gender toggle:', initialGender);
    }
    
    updateSizePillsDisplay(initialGender); // Update size pill texts/availability based on initial gender
    updateAvailableOptions(null); // Update all other options' availability and select the final variant
                                  // This will also make the final call to updateSelectedVariant().

    // E. SUB-PRODUCT OPTION HANDLING
    console.log('[DEBUG] setTimeout: Setting up sub-product event listeners.');

    const updateSubProductDisplay = function(subProductId) {
      if (!subProductId || !window.subProductsData || !window.subProductsData[subProductId]) {
        console.error('[DEBUG] updateSubProductDisplay: Missing subProductId or sub-product data for ID:', subProductId);
        return;
      }
      const subProductData = window.subProductsData[subProductId];

      // --- SAFEGUARDS ---------------------------------------------------------
      if (!subProductData) {
        console.error('[DEBUG] updateSubProductDisplay: subProductData undefined for', subProductId);
        return;
      }

      // Ensure we have variants array
      if (!Array.isArray(subProductData.variants) || subProductData.variants.length === 0) {
        const containerEl = document.querySelector(`.sub-product-container[sf-product="${subProductId}"]`);
        const handleFromDom = containerEl ? containerEl.dataset.productHandle : null;
        const handleToFetch = subProductData.handle || handleFromDom;
        if (!handleToFetch) {
            console.error('[DEBUG] No handle to fetch product JSON for sub-product', subProductId);
            return;
        }
        console.warn('[DEBUG] Missing variants; fetching JSON for handle', handleToFetch);
        fetch(`/products/${handleToFetch}.js`)
          .then(resp => {
            if(!resp.ok){
              console.warn('[DEBUG] fetch .js failed status',resp.status,'-> trying .json');
              return fetch(`/products/${handleToFetch}.json`);
            }
            return resp;
          })
          .then(resp=>{
            if(!resp.ok){
              console.warn('[DEBUG] fetch .json failed status',resp.status,'-> trying by numeric ID');
              return fetch(`/products/${subProductId}.js`);
            }
            return resp;
          })
          .then(r=> r.ok ? r.json() : Promise.reject(r))
          .then(fullData => {
            console.log('[DEBUG] Fetched product JSON for sub-product',subProductId, fullData);
            if (fullData && Array.isArray(fullData.variants) && fullData.variants.length) {
              if (!fullData.options_by_name && Array.isArray(fullData.options)) {
                fullData.options_by_name = {};
                fullData.options.forEach((optName, idx) => {
                  fullData.options_by_name[optName] = { name: optName, position: idx + 1, values: [...new Set(fullData.variants.map(v=>v.options[idx]))] };
                });
              }
              window.subProductsData[subProductId] = fullData;
              console.log('[DEBUG] Reloaded sub-product data with variants for', subProductId);
              updateSubProductDisplay(subProductId);
            }
          })
          .catch(err => console.error('[DEBUG] Fetch error for sub-product handle', handleToFetch, err));
        return;
      }

      const formElement = document.querySelector(`.form.sub-product-form[data-sub-product-form="${subProductId}"]`);
      if (!formElement) {
        console.error('[DEBUG] updateSubProductDisplay: Could not find form for subProductId:', subProductId);
        return;
      }

      const selectedOptions = {};
      // Get selections from color swatches (via hidden select)
      const colorHiddenSelect = formElement.querySelector('.sub-product-hidden-select[name*="Color"], .sub-product-hidden-select[name*="Colour"] '); // Case-insensitive enough
      if (colorHiddenSelect) {
        const colorOptionName = colorHiddenSelect.name.match(/options\[(.*?)\]/)[1];
        if (colorHiddenSelect.value) {
            selectedOptions[colorOptionName] = colorHiddenSelect.value;
        }
      }

      // Get selections from other standard selects (like size)
      formElement.querySelectorAll('select.select__select:not(.sub-product-hidden-select)').forEach(selectElement => {
        const optionName = selectElement.name.match(/options\[(.*?)\]/)[1];
        if (selectElement.value) {
            selectedOptions[optionName] = selectElement.value;
        }
      });
      
      console.log(`[DEBUG] updateSubProductDisplay (${subProductId}): Selected options:`, selectedOptions);

      let matchedVariant = null;
      let bestMatchAvailable = null;

      subProductData.variants.forEach(variant => {
        let allOptionsMatch = true;
        let atLeastOneSelection = false; // Track if the user has selected something
        for (const optionNameInProduct in subProductData.options_by_name) {
            const productOptionDetail = subProductData.options_by_name[optionNameInProduct];
            const selectedValue = selectedOptions[productOptionDetail.name];

            // Skip comparison for options the customer has *not* interacted with (allows hidden/unselectable options)
            if (typeof selectedValue === 'undefined') {
                continue; // do not disqualify the variant – simply ignore this option
            }

            atLeastOneSelection = true;
            const variantOptionValue = variant.options[productOptionDetail.position - 1];
            if (String(variantOptionValue).toLowerCase() !== String(selectedValue).toLowerCase()) {
                allOptionsMatch = false;
                break;
            }
        }

        // Ensure we only treat variants as matches if they satisfy *all* selections that exist.
        if (allOptionsMatch && atLeastOneSelection) {
            if (variant.available) {
                if (!bestMatchAvailable) bestMatchAvailable = variant;
            }
            if (!matchedVariant) matchedVariant = variant; // Keep first match as a fallback
        }
      });

      if (bestMatchAvailable) {
        matchedVariant = bestMatchAvailable;
      }
      
      console.log(`[DEBUG] updateSubProductDisplay (${subProductId}): Matched variant:`, matchedVariant ? matchedVariant.id : 'None', 'Available:', matchedVariant ? matchedVariant.available : 'N/A');

      const variantIdInput = formElement.querySelector('input[name="id"]');
      const priceDisplay = formElement.closest('.sub-product-container').querySelector('.sub-product-price');
      const atcButton = formElement.querySelector('.product-form__submit.sub-product-adder');
      const atcButtonTextSpan = atcButton ? atcButton.querySelector('.add-to-cart-text') : null;

      if (matchedVariant) {
        if (variantIdInput) variantIdInput.value = matchedVariant.id;
        let formattedPrice = formatPriceFallback(matchedVariant.price, window.shopCurrency || '$');
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) { 
            try { formattedPrice = Shopify.formatMoney(matchedVariant.price, Shopify.money_format || window.Shopify.currency.money_format || '%${{amount}}'); } catch (e) { console.warn("Shopify.formatMoney error for sub-product", e); } 
        }
        if (priceDisplay) priceDisplay.textContent = formattedPrice;
        if (atcButton && atcButtonTextSpan) {
          if (matchedVariant.available) {
            atcButtonTextSpan.textContent = 'Add to Cart'; // Or localized version
            atcButton.disabled = false;
          } else {
            atcButtonTextSpan.textContent = soldOutText; // Use global soldOutText
            atcButton.disabled = true;
          }
        }
      } else {
        if (variantIdInput) variantIdInput.value = '';
        if (priceDisplay) priceDisplay.textContent = '---'; // Or unavailableText
        if (atcButton && atcButtonTextSpan) {
          atcButtonTextSpan.textContent = unavailableText; // Use global unavailableText
          atcButton.disabled = true;
        }
      }
    };

    document.querySelectorAll('.sub-product-form').forEach(form => {
      const subProductId = form.dataset.subProductForm;
      if (!subProductId) return;

      // Listener for color swatches
      form.querySelectorAll('.sub-product-color-swatch').forEach(swatch => {
        swatch.addEventListener('click', function() {
          console.log(`[DEBUG] Sub-product (${subProductId}) color swatch click:`, this.dataset.value);
          const wrapper = this.closest('.sub-product-color-option-wrapper');
          if (!wrapper) return;
          wrapper.querySelectorAll('.sub-product-color-swatch').forEach(s => s.classList.remove('is-active'));
          this.classList.add('is-active');
          const hiddenSelect = wrapper.querySelector('.sub-product-hidden-select');
          if (hiddenSelect) {
            hiddenSelect.value = this.dataset.value;
            hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
          updateSubProductDisplay(subProductId);
        });
      });

      // Listener for standard select dropdowns (like size)
      form.querySelectorAll('select.select__select:not(.sub-product-hidden-select)').forEach(selectElement => {
        selectElement.addEventListener('change', function() {
          console.log(`[DEBUG] Sub-product (${subProductId}) select change:`, this.name, this.value);
          updateSubProductDisplay(subProductId);
        });
      });
      
      // Initial update for each sub-product based on pre-selected options
      if (window.subProductsData && window.subProductsData[subProductId]) {
        console.log(`[DEBUG] Initial updateSubProductDisplay call for subProductId: ${subProductId}`);
        updateSubProductDisplay(subProductId);
      }

    });

    const handleAjaxAddToCart = async function(event) {
      event.preventDefault();
      const form = event.target;
      if (form.dataset.ajaxAtcSubmitting === 'true') {
        return;
      }
      form.dataset.ajaxAtcSubmitting = 'true';
      const submitStartTs = Date.now();
      const MIN_ATC_FEEDBACK_MS = 1200;
      const submitButton = form.querySelector('.product-form__submit');
      const spinner = submitButton ? submitButton.querySelector('.loading-overlay__spinner') : null;
      const atcButtonText = submitButton ? submitButton.querySelector('.add-to-cart-text') : null;
      const originalButtonText = atcButtonText ? atcButtonText.textContent : 'Add to Cart';
      let externalPendingToken = null;
      let hadError = false;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-cart-loading-btn');
      }
      if (spinner) spinner.style.display = 'none';
      if (atcButtonText) {
        atcButtonText.textContent = 'Adding...';
        atcButtonText.style.display = 'inline';
      }

      const formData = new FormData(form);
      const variantId = formData.get('id');

      if (!variantId) {
        console.error('AJAX ATC: Variant ID not found in form.');
        if (atcButtonText) atcButtonText.textContent = 'Error: No Variant';
        hadError = true;
        // No early return, let finally handle button state
      } else {
        const lineItemProperties = {};
        formData.forEach((value, key) => {
          const keyString = String(key || '');
          if (!keyString.startsWith('properties[') || !keyString.endsWith(']')) return;
          const propertyKey = keyString.slice(11, -1);
          const propertyValue = String(value == null ? '' : value).trim();
          if (!propertyKey || !propertyValue) return;
          lineItemProperties[propertyKey] = propertyValue;
        });

        const lineItemPayload = {
          id: variantId,
          quantity: 1
        };
        if (Object.keys(lineItemProperties).length) {
          lineItemPayload.properties = lineItemProperties;
        }

        const body = {
          items: [lineItemPayload]
        };

        try {
          if (
            window.Valsole &&
            window.Valsole.Cart &&
            typeof window.Valsole.Cart.beginExternalPending === 'function'
          ) {
            externalPendingToken = window.Valsole.Cart.beginExternalPending({
              type: 'item',
              message: 'Adding item...',
              label: 'Adding item...'
            });
          }
          window.__valsoleUserAddIntentTs = Date.now();
          if (!window.__valsoleCartAddState) {
            window.__valsoleCartAddState = { inFlight: false, lastRun: 0 };
          }
          const addState = window.__valsoleCartAddState;
          const now = Date.now();
          if (addState.inFlight || (now - addState.lastRun < 800)) {
            throw new Error('Add-to-cart throttled. Please try again.');
          }
          addState.inFlight = true;
          addState.lastRun = now;
          const response = await fetch('/cart/add.js?__valsole_mut=1', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Valsole-Cart-Allow-Mutation': '1'
            },
            body: JSON.stringify(body)
          });

          if (window.ValsoleCartChallenge) {
            const securityError = await window.ValsoleCartChallenge.responseError(response, 'pdp', body);
            if (securityError) throw securityError;
          }

          if (!response.ok) {
            let errorMessage = `Error ${response.status}`;
            try {
              const errorData = await response.json();
              errorMessage = errorData.description || errorMessage;
            } catch (e) {
              // Keep default message when response is not JSON (e.g., 429 HTML)
            }
            throw new Error(errorMessage);
          }

          const responseData = await response.json();
          console.log('AJAX ATC: Product added successfully', responseData);

          const nextReadSafeAt = Date.now() + 9000;
          const currentReadSafeAt = Number(window.__valsoleCartReadDeferredUntil || 0);
          window.__valsoleCartReadDeferredUntil = Math.max(currentReadSafeAt, nextReadSafeAt);
          const nextMutationSafeAt = Date.now() + 9000;
          const currentMutationSafeAt = Number(window.__valsoleCartMutationSoftBlockUntil || 0);
          window.__valsoleCartMutationSoftBlockUntil = Math.max(currentMutationSafeAt, nextMutationSafeAt);

          if (window.Valsole && window.Valsole.Cart && typeof window.Valsole.Cart.open === 'function') {
            window.Valsole.Cart.open(); 
          } else {
            console.error('Valsole.Cart.open() function not found. Cannot open cart popup.');
            if (
              externalPendingToken &&
              window.Valsole &&
              window.Valsole.Cart &&
              typeof window.Valsole.Cart.endExternalPending === 'function'
            ) {
              window.Valsole.Cart.endExternalPending(externalPendingToken, {
                success: false,
                errorMessage: 'Cart panel unavailable'
              });
              externalPendingToken = null;
            }
            // Fallback: redirect to cart page or show a success message
            // window.location.href = '/cart';
          }
          
          // Avoid extra /cart.js fetch here; the cart popup fetch on open will sync counts.
          // If you need header count immediately, consider a single debounced fetch elsewhere.

        } catch (error) {
          console.error('AJAX ATC Error:', error);
          const securityRecoveryShown = window.ValsoleCartChallenge && window.ValsoleCartChallenge.show(error, body);
          if (
            externalPendingToken &&
            window.Valsole &&
            window.Valsole.Cart &&
            typeof window.Valsole.Cart.endExternalPending === 'function'
          ) {
            window.Valsole.Cart.endExternalPending(externalPendingToken, {
              success: false,
              errorMessage: 'Add to cart failed'
            });
            externalPendingToken = null;
          }
          if (atcButtonText) atcButtonText.textContent = securityRecoveryShown ? 'Continue security check' : 'Error';
          hadError = true;
        } finally {
          if (window.__valsoleCartAddState) {
            window.__valsoleCartAddState.inFlight = false;
          }
          // Clear user intent shortly after to prevent non-user scripts from calling /cart/add.js
          setTimeout(() => {
            if (window.__valsoleUserAddIntentTs) {
              window.__valsoleUserAddIntentTs = 0;
            }
          }, 1500);
        }
      }

      const elapsed = Date.now() - submitStartTs;
      if (elapsed < MIN_ATC_FEEDBACK_MS) {
        await new Promise((resolve) => setTimeout(resolve, MIN_ATC_FEEDBACK_MS - elapsed));
      }

      // Finally block equivalent logic since await cannot be in a finally block that affects button state restoration timing relative to other async ops within try/catch
      if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('is-cart-loading-btn');
          if (spinner) spinner.style.display = 'none';
          if (atcButtonText) {
              if (hadError) {
                  // Keep 'Error' text or revert after a timeout
                  setTimeout(() => {
                      atcButtonText.textContent = originalButtonText;
                      atcButtonText.style.display = 'inline';
                  }, 3000); // Revert after 3 seconds
              } else {
                  atcButtonText.textContent = originalButtonText; // Or "Added!" then revert
                  atcButtonText.style.display = 'inline';
              }
          }
      }
      delete form.dataset.ajaxAtcSubmitting;
    };

    if (typeof window !== 'undefined') {
      window.ValsolePDP = window.ValsolePDP || {};
      window.ValsolePDP.handleAjaxAddToCart = handleAjaxAddToCart;
    }

    // Attach AJAX ATC to main and floating forms
    const mainProductFormATC = document.querySelector('form[data-type="add-to-cart-form"]:not(.sub-product-form)');
    if (mainProductFormATC) {
      if (mainProductFormATC.dataset.ajaxAtcBound !== 'true') {
        mainProductFormATC.addEventListener('submit', handleAjaxAddToCart);
        mainProductFormATC.dataset.ajaxAtcBound = 'true';
      }
      console.log('[DEBUG] AJAX ATC listener attached to main product form.');
    }

    const floatingCartFormATC = document.querySelector('.floating-cart-form');
    if (floatingCartFormATC) {
      if (floatingCartFormATC.dataset.ajaxAtcBound !== 'true') {
        floatingCartFormATC.addEventListener('submit', handleAjaxAddToCart);
        floatingCartFormATC.dataset.ajaxAtcBound = 'true';
      }
      console.log('[DEBUG] AJAX ATC listener attached to floating cart form.');
    }
    
    // Attach AJAX ATC to sub-product forms if they exist and should also trigger the popup
    const subProductForms = document.querySelectorAll('.sub-product-form[data-sub-product-form]');
    subProductForms.forEach(form => {
      if (form.dataset.ajaxAtcBound !== 'true') {
        form.addEventListener('submit', handleAjaxAddToCart);
        form.dataset.ajaxAtcBound = 'true';
      }
      console.log('[DEBUG] AJAX ATC listener attached to sub-product form:', form.dataset.subProductForm);
    });

    console.log('[DEBUG] setTimeout: Main logic execution finished.');
  }, 500); // End of setTimeout

  console.log('[DEBUG] DOMContentLoaded: Event handler initial tasks finished, setTimeout scheduled.');

  // Recalcular colorOptionIndex ahora que product está garantizado
  computeColorOptionIndex();
  console.log('[DEBUG] colorOptionIndex', colorOptionIndex);

  if (typeof window !== 'undefined') {
    if (!Array.isArray(window.colorGalleries) && Array.isArray(window.colorGaleries)) {
      window.colorGalleries = window.colorGaleries;
      console.log('[DEBUG] colorGalleries alias assigned from colorGaleries');
    }
  }
});

// Helper function for price formatting (remains global as it's self-contained)
function formatPriceFallback(cents, currencySymbol = '$') {
  if (typeof cents !== 'number' || isNaN(cents)) {
    console.warn('[DEBUG] formatPriceFallback: cents is not a number or NaN', cents);
    return '';
  }
  const symbol = (typeof currencySymbol === 'string' && currencySymbol.trim() !== '') ? currencySymbol : '$';
  const dollars = cents / 100;
  return `${symbol}${dollars.toFixed(2)}`;
}

// === UTILIDADES DE GALERÍA POR COLOR ===
let colorOptionIndex = -1; // se recalculará cuando window.product esté disponible

function computeColorOptionIndex() {
  if (typeof window !== 'undefined' && window.product && Array.isArray(window.product.options)) {
    for (let i = 0; i < window.product.options.length; i++) {
      const name = String(window.product.options[i]).toLowerCase();
      if (name === 'color' || name === 'colour' || name.includes('color')) {
        colorOptionIndex = i;
        break;
      }
    }
  }

  if (colorOptionIndex === -1 && window.product && window.product.variants && window.product.variants.length) {
    const firstVar = window.product.variants[0];
    if (firstVar && firstVar.options) {
      const colorKeywords = ['black','blue','grey','gray','red','white','green','yellow','pink','purple','brown','beige','orange'];
      firstVar.options.forEach((opt,i)=>{
        if (typeof opt === 'string' && colorKeywords.some(k=>opt.toLowerCase().includes(k))) {
          colorOptionIndex = i;
        }
      });
    }
  }
}

// Intentar calcular inmediatamente por si product ya existe
computeColorOptionIndex();

// Utilidad para extraer la URL de una imagen desde distintos formatos
const extractSrc = (m) => {
  const isValid = (u) => typeof u === 'string' && (u.startsWith('http') || u.startsWith('//'));
  if (m.preview_image) {
    if (isValid(m.preview_image.src)) return m.preview_image.src;
    if (isValid(m.preview_image.url)) return m.preview_image.url;
  }
  if (isValid(m.src)) return m.src;
  if (isValid(m.url)) return m.url;
  return '';
};

const extractAlt = (m) => {
  if (!m) return '';
  if (m.alt) return m.alt;
  if (m.preview_image && m.preview_image.alt) return m.preview_image.alt;
  return '';
};

const normalizeMediaSignatureUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.delete('width');
    parsed.searchParams.delete('v');
    return `${parsed.origin}${parsed.pathname}`;
  } catch (error) {
    return url.split('?')[0];
  }
};

const getGridImageSignature = (images) => {
  if (!Array.isArray(images) || images.length === 0) return '';
  return images
    .slice(0, 5)
    .map((img) => normalizeMediaSignatureUrl(extractSrc(img)))
    .filter(Boolean)
    .join('|');
};

const getCurrentGridSignature = (grid) => {
  if (!grid) return '';
  return Array.from(grid.querySelectorAll('.pdp-media-grid-item img'))
    .map((img) => normalizeMediaSignatureUrl(img.currentSrc || img.src || ''))
    .filter(Boolean)
    .join('|');
};

const escapePdpImageAttr = (value) => String(value || '')
  .replace(/&/g, '&amp;')
  .replace(/"/g, '&quot;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

const pdpImageUrlWithWidth = (src, width) => {
  const cleanSrc = String(src || '')
    .replace(/([?&])width=\d+/g, '$1')
    .replace(/[?&]$/, '')
    .replace('?&', '?');
  const separator = cleanSrc.includes('?') ? '&' : '?';
  return `${cleanSrc}${separator}width=${width}`;
};

const buildPdpGridImageTag = (src, alt, index) => {
  const loading = index === 0 ? 'eager' : 'lazy';
  const fetchpriority = index === 0 ? 'high' : 'auto';
  const widths = [480, 640, 800, 960, 1200, 1600];
  const srcset = widths.map(width => `${pdpImageUrlWithWidth(src, width)} ${width}w`).join(', ');
  return `<img src="${escapePdpImageAttr(pdpImageUrlWithWidth(src, 1200))}" srcset="${escapePdpImageAttr(srcset)}" sizes="(min-width: 1200px) 22vw, (min-width: 768px) 26vw, 92vw" alt="${escapePdpImageAttr(alt)}" loading="${loading}" fetchpriority="${fetchpriority}" decoding="async" class="vs-pdp-image-fade">`;
};

// Reemplazo del bloque getImagesForVariant existente
const getImagesForVariant = function(variant) {
  let result = [];
  // 1. Si hay galería por color via metafields
  if (variant && Array.isArray(window.colorGalleries) && window.colorGalleries.length && colorOptionIndex !== -1) {
    const colorValue = (variant.options && variant.options[colorOptionIndex]) ? String(variant.options[colorOptionIndex]).trim().toLowerCase() : null;
    if (colorValue) {
      // Robust normalization to handle spaces, special chars, etc.
      const normalize = (s) => String(s || '').replace(/[^a-z0-9]/gi, '').toLowerCase();
      const galleryObj = window.colorGalleries.find(g => (g.value && normalize(g.value) === normalize(colorValue)) || (g.handle && normalize(g.handle) === normalize(colorValue)));
      if (galleryObj && Array.isArray(galleryObj.images) && galleryObj.images.length) {
        result = galleryObj.images.map(img => ({ src: extractSrc(img), alt: extractAlt(img) }));
      }
    }
  }

  // 2. Fallback a variant_ids filtrado
  if (result.length === 0 && variant && Array.isArray(product.media)) {
    result = product.media
      .filter(m => m.media_type === 'image' && Array.isArray(m.variant_ids) && m.variant_ids.includes(variant.id))
      .map(m => ({ src: extractSrc(m), alt: extractAlt(m) }));
  }

  // 3. Fallback a todas las imágenes
  if (result.length === 0 && Array.isArray(product.media)) {
    result = product.media
      .filter(m => m.media_type === 'image')
      .map(m => ({ src: extractSrc(m), alt: extractAlt(m) }));
  }
  return result;
};

// Reemplazo de updateMediaGridByVariant para usar extractSrc()
const updateMediaGridByVariant = function(variant) {
  const grid = document.querySelector('.pdp-media-image-grid');
  if (!grid) return;
  const imgs = getImagesForVariant(variant);
  if (!Array.isArray(imgs) || imgs.length === 0) {
    console.warn('[updateMediaGridByVariant] No images found for variant, keeping existing grid.');
    return; // no sobreescribir con vacío
  }

  const nextSignature = getGridImageSignature(imgs);
  const currentSignature = grid.dataset.mediaSignature || getCurrentGridSignature(grid);
  if (nextSignature && currentSignature && nextSignature === currentSignature) {
    console.log('[updateMediaGridByVariant] Skipping identical grid repaint.');
    grid.dataset.mediaSignature = nextSignature;
    return;
  }

  const MAX_IMAGES = 5;
  let html = '';
  imgs.slice(0, MAX_IMAGES).forEach((img, idx) => {
    const src = extractSrc(img);
    if (!src) return; // skip empties
    const alt = extractAlt(img);
    html += `<div class="pdp-media-grid-item">${buildPdpGridImageTag(src, alt, idx)}</div>`;
  });
  const emptySlots = MAX_IMAGES - Math.min(imgs.length, MAX_IMAGES);
  for (let i = 0; i < emptySlots; i++) {
    html += '<div class="pdp-media-grid-item is-empty"></div>';
  }
  grid.innerHTML = html;
  if (nextSignature) {
    grid.dataset.mediaSignature = nextSignature;
  }
};

// ============================================
// Klaviyo Star Rating Repositioning
// ============================================
// Move Klaviyo stars from Apps section to below product title

(function repositionKlaviyoStars() {
  console.log('► Klaviyo Star Reposition - Running...');

  function moveStars() {
    // Find the product header/title block
    const productTitle = document.querySelector('[data-block-type="product_header"], .product-header, .product-title, .pdp_content h1');

    // Find the Apps section (Klaviyo container)
    const appsSection = document.querySelector('.shopify-section--apps, [id*="shopify-section"][id*="apps"]');

    if (!productTitle) {
      console.log('[Klaviyo] Product title not found');
      return false;
    }

    if (!appsSection) {
      console.log('[Klaviyo] Apps section not found');
      return false;
    }

    // Check if already moved
    if (appsSection.dataset.klaviyoMoved === 'true') {
      console.log('[Klaviyo] Already repositioned');
      return true;
    }

    // Create wrapper for stars
    const starsWrapper = document.createElement('div');
    starsWrapper.className = 'klaviyo-stars-wrapper';
    starsWrapper.style.cssText = 'margin-top: 16px; margin-bottom: 24px;';

    // Move Apps section content into wrapper
    while (appsSection.firstChild) {
      starsWrapper.appendChild(appsSection.firstChild);
    }

    // Insert after title
    productTitle.parentNode.insertBefore(starsWrapper, productTitle.nextSibling);

    // Hide original Apps section
    appsSection.style.display = 'none';
    appsSection.dataset.klaviyoMoved = 'true';

    console.log('[Klaviyo] ✓ Stars repositioned below title');
    return true;
  }

  // Try immediately
  if (!moveStars()) {
    // Retry after delay
    setTimeout(moveStars, 500);
    setTimeout(moveStars, 1000);
    setTimeout(moveStars, 2000);
  }
})();
